import {
    PieChart,
    Pie,
    Cell,
    Legend,
    ResponsiveContainer,
} from "recharts";
import { useEffect, useState } from "react";
import { ParticipantData } from "../utils/partners";

type ProgramPieProps = {
    data: ParticipantData[];
    height?: number;
};

export default function ProgramPie({
    data,
    height = 220,
}: ProgramPieProps) {
    const COLORS = [
        "#0B5D7A",
        "#7CB342",
        "#C0C0C0",
        "#2E9AD0",
        "#6A1B9A",
        "#FF8F00",
        "#E53935",
        "#616161",
    ];

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(max-width: 639px)");

        const handleChange = (e: MediaQueryListEvent | MediaQueryList) => {
        setIsMobile(e.matches);
        };

        handleChange(mediaQuery);

        const listener = (e: MediaQueryListEvent) => handleChange(e);

        mediaQuery.addEventListener("change", listener);
        return () => mediaQuery.removeEventListener("change", listener);
    }, []);

    const renderPercentLabel = (props: any) => {
        const { cx, cy, midAngle, innerRadius, outerRadius, percent } = props;

        if (!percent || percent < 0.02) return null;

        const RAD = Math.PI / 180;
        const radius = innerRadius + (outerRadius - innerRadius) / 2;
        const x = cx + radius * Math.cos(-midAngle * RAD);
        const y = cy + radius * Math.sin(-midAngle * RAD);

        return (
        <text
            x={x}
            y={y}
            fill="white"
            textAnchor="middle"
            dominantBaseline="central"
            fontSize={isMobile ? 9 : 10}
            fontWeight={700}
        >
            {`${Math.round(percent * 100)}%`}
        </text>
        );
    };

    const legendFormatter = (value: any) => (
        <span
        style={{
            color: "#111827",
            fontWeight: 500,
            fontSize: isMobile ? 12 : 10,
        }}
        >
        {value}
        </span>
    );

    const chartData = data.map((d) => ({
        name: d.label,
        value: d.value,
    }));

    const chartHeight = isMobile ? Math.max(height, 320) : height;

    return (
        <div className="w-full min-w-0">
        <div className="w-full min-w-0" style={{ height: chartHeight }}>
            <ResponsiveContainer width="100%" height="100%">
            <PieChart>
                <Pie
                    data={chartData}
                    dataKey="value"
                    nameKey="name"
                    cx={isMobile ? "50%" : "35%"}
                    cy={isMobile ? "42%" : "50%"}
                    innerRadius={isMobile ? "32%" : "40%"}
                    outerRadius={isMobile ? "68%" : "85%"}
                    paddingAngle={1}
                    labelLine={false}
                    label={renderPercentLabel}
                    isAnimationActive={false}
                >
                    {chartData.map((_, i) => (
                        <Cell key={i} fill={COLORS[i % COLORS.length]} />
                    ))}
                </Pie>

                <Legend
                    layout={isMobile ? "horizontal" : "vertical"}
                    verticalAlign={isMobile ? "bottom" : "middle"}
                    align={isMobile ? "center" : "right"}
                    iconType="square"
                    iconSize={10}
                    formatter={legendFormatter}
                    wrapperStyle={
                        isMobile
                        ? {
                            top: "80%",
                            left: 8,
                            right: 0,
                            fontSize: 12,
                            textAlign: "center"
                            }
                        : {
                            right: 20,
                            }
                    }
                />
            </PieChart>
            </ResponsiveContainer>
        </div>
        </div>
    );
}